import Vue from 'vue';
import { Vue2Storage } from 'vue2-storage';

Vue.use(Vue2Storage, {
  prefix: 'ardi-quest-',
  ttl: 60 * 60 * 24 * 1000,
});
